import * as yup from 'yup'
import { usernameFieldSchema } from 'src/component/shared'
import { Gender, HeightUnit, WeightUnit } from 'src/dao/core-dao'

const optionalPositiveNumberString = (fieldName: string): yup.StringSchema =>
  yup
    .string()
    .optional()
    .default('')
    .test('valid-number', `${fieldName} must be a valid number`, (value) => {
      if (!value || value === '') return true
      const numValue = parseFloat(value)
      return !isNaN(numValue)
    })
    .test('positive', `${fieldName} must be greater than zero`, (value) => {
      if (!value || value === '') return true
      return parseFloat(value) > 0
    })

export const updatePersonalDetailsValidationSchema = yup.object({
  username: usernameFieldSchema,
  gender: yup
    .string()
    .oneOf([...Object.values(Gender), '', null])
    .optional()
    .nullable(),
  dateOfBirth: yup.string().optional().nullable(),
  heightValue: optionalPositiveNumberString('Height'),
  heightUnit: yup
    .string()
    .oneOf(Object.values(HeightUnit) as string[])
    .required(),
  weightValue: optionalPositiveNumberString('Weight'),
  weightUnit: yup
    .string()
    .oneOf(Object.values(WeightUnit) as string[])
    .required(),
})

export type UpdatePersonalDetailsFormData = yup.InferType<typeof updatePersonalDetailsValidationSchema>
